import { FormattedMessage } from 'react-intl'
import _get from 'lodash/get';
import Modal from '@/shared/ui/Modal';
import Title from '@/shared/ui/Title';
import { VIEWS, useNavigation } from "@/processes/Router";
import { PayoutsChart, PayoutsTable } from '~/sha256/Payouts';

type PayoutsModalProps = {
  className?: string;
}

const PayoutsModal = (props: PayoutsModalProps) => {
  const { className } = props;
  const { view, updateURLQueryParams } = useNavigation();
  const isShow = view === VIEWS.PAYOUTS;

  const handleClose = () => {
    updateURLQueryParams({ view: null });
  };

  return (
    <Modal 
      title={
        <Title order={3} size='2xl'>
          <FormattedMessage id="payouts"/>
        </Title>
      }
      show={isShow}
      onDismiss={handleClose}
      className={className} 
    >
      <PayoutsChart/> 
      <PayoutsTable className='mt-6'/> 
    </Modal>
  );
}

export default PayoutsModal;
